import { AxiosError } from 'axios';

import { FetchError } from '@project44/ui-utils';
import { ErrorResponseJSONInterface } from '@project44/ui-utils/src/interfaces/ErrorResponseJSONInterface';

export class ApiClientError {
  public static readonly DEFAULT_MESSAGE: string = 'Unknown Error';
  public readonly composeFetchError = (
    unknownException: unknown,
  ): FetchError => {
    return this.isAxiosError(unknownException)
      ? this.handleAxiosError(
          unknownException as AxiosError<ErrorResponseJSONInterface>,
        )
      : this.handleUnknownError(unknownException);
  };

  public static composeFetchError = (unknownException: unknown): FetchError => {
    return new ApiClientError().composeFetchError(unknownException);
  };

  private readonly isAxiosError = (
    unknownException: unknown,
  ): unknownException is AxiosError => {
    return (unknownException as AxiosError).isAxiosError;
  };

  private readonly handleUnknownError = (
    unknownException: unknown,
  ): FetchError => {
    const errorMessage =
      (unknownException as Error)?.message || ApiClientError.DEFAULT_MESSAGE;

    return new FetchError(errorMessage, 500, {
      supportReferenceId: 'N/A',
      errorMessage,
      httpStatusCode: 500,
      httpMessage: errorMessage,
    });
  };

  private readonly handleAxiosError = (
    axiosError: AxiosError<ErrorResponseJSONInterface>,
  ): FetchError => {
    return new FetchError(
      axiosError.response?.data.errorMessage || ApiClientError.DEFAULT_MESSAGE,
      axiosError.status,
      axiosError.response?.data,
    );
  };
}
